import { useFulfillmentStatusLang } from 'hooks/language/useFulfillmentStatusLang';
import { FinancialStatus, FulfillmentStatus, Order } from 'models/Order';
import { TFunction } from 'i18next';
import { PackageProviderName } from '../../../data/ppoints/constants';

enum OrdersTableColumn {
    order_number,
    created_at,
    customer,
    shipping_provider,
    total,
    payment_status,
    fulfillment_status,
    tracking_number,
}

const getOrderFulfillmentStatusDisplayText = (status: FulfillmentStatus) => {
    if (!status) return useFulfillmentStatusLang(status);
    return useFulfillmentStatusLang(status); //status[0].toUpperCase() + status.slice(1).replace(/_/i, ' ');
};
const getOrderFinancialStatusDisplayText = (status: FinancialStatus) => {
    if (!status) return /*useFinancialStatusLang(status); */ 'Unpaid';
    return /*useFinancialStatusLang(status); */ status[0].toUpperCase() + status.slice(1).replace(/_/i, ' ');
};

const getFormattedDate = (date) => {
    const today = new Date(date);
    const yyyy = today.getFullYear();
    let MM = String(today.getMonth() + 1).padStart(2, '0');
    let DD = String(today.getDate()).padStart(2, '0');
    let hh = String(today.getHours()).padStart(2, '0');
    let mm = String(today.getMinutes()).padStart(2, '0');
    let ss = String(today.getSeconds()).padStart(2, '0');
    return `${yyyy}-${MM}-${DD} ${hh}:${mm}:${ss}`;
};

export { OrdersTableColumn };

export const getFulfillmentStatus = (orders: Order[], orderId: number) => {
    if (orders) {
        const fulfillmentStatus = orders.find((order) => order.id === orderId.toString());
        return fulfillmentStatus?.providerInfo?.fulfillmentStatus;
    } else return 'Not found';
};

export const getPaymentStatus = (orders: Order[], orderId: number) => {
    if (orders) {
        const paymentStatus = orders.find((order) => order.id === orderId.toString());
        return paymentStatus?.providerInfo?.paymentStatus;
    } else return 'Not found';
};

export const getProvider = (orders: Order[], orderId: number): PackageProviderName | undefined => {
    if (orders) {
        const provider = orders.find((order) => order.id === orderId.toString());
        return provider?.providerInfo?.type;
    }
};

export const getOrder = (orders: Order[], orderId: number): Order | undefined => {
    if (orders) {
        const order = orders.find((order) => order.id === orderId.toString());
        return order;
    }
};

export const getTranslatedManifestStatus = (status: string, t: TFunction) => {
    let manifestStatus = '';

    switch (status) {
        case 'closed':
            manifestStatus = t('MANIFEST_STATUS.CLOSED');
            break;
        case 'open':
            manifestStatus = t('MANIFEST_STATUS.OPEN');
            break;
    }
    return manifestStatus;
};

export const getTranslatedFulfillmentStatus = (status: string, t: TFunction) => {
    let fulfillmentStatus = '';

    switch (status) {
        case null:
        case 'unfulfilled':
            fulfillmentStatus = t('FULFILLMENT_STATUS.UNFULFILLED');
            break;
        case 'partial':
            fulfillmentStatus = t('FULFILLMENT_STATUS.PARTIAL');
            break;
        case 'fulfilled':
            fulfillmentStatus = t('FULFILLMENT_STATUS.FULFILLED');
            break;
    }
    return fulfillmentStatus;
};

export default {
    getOrderFulfillmentStatusDisplayText,
    getOrderFinancialStatusDisplayText,
    getFormattedDate,
};
